/// <reference path="../typings.d.ts" />
import { Component } from '@angular/core';
import { AppTitle } from './shared/title';
import { IdentityService } from './services/identity.service';
import { Router, RouterOutlet } from '@angular/router';
import { Account, validateToken } from './services/account.service';
import { Alert } from './shared/alert';
import { UserRoles } from './models/user_roles';
import { AppService } from './services/app.service';

@Component({
	selector: 'identity-access',
	template: `
	<div class="row">
		<div class="col-lg-5 col-md-6 col-xs-12">
			<alert [alert]="msg"></alert>
			<p>Click a school name to switch the school or click the checkbox to make a default school in the next login.</p>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-5 col-md-6 col-xs-12">
			<div class="card scrollable">
				<table class="table">
					<thead>
						<tr>
							<th>AcctNumber</th>
							<th>Schools</th>
							<th>Is Default</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of data; let i = index">
							<td style="width:130px;">{{row.acctNumber}}</td>
							<td style=""><a (click)="changeUserRoles(i)" style="cursor: pointer;">{{row.schoolName}}</a></td>
							<td style="width:80px;">
								<input [(ngModel)]="row.isDefault" type="checkbox" (change)="setDefault(i)" [checked]="row.isDefault" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
  `
})

export class IdentityAccessComponent {
	data: UserRoles[];
	msg: Alert;
	constructor(
		private router: Router,
		private title: AppTitle,
		private account: Account,
		private isvc: IdentityService,
		private app: AppService,
	) {
		this.msg = new Alert();
		title.setTitles({
			title: 'Identity Access',
			dashboard: 'Identity Access'
		});
		title.setBreadcrumbs([
			{ title: 'Identity Access', link: '' }
		]);
		this.loadData();
	}

	loadData() {
		if (validateToken()) {
			this.isvc.userRolesApi().subscribe((urs: UserRoles[]) => {
				this.data = urs;

				// Sort list by school name
				this.data.sort((a, b) => (a.schoolName > b.schoolName) ? 1 : ((b.schoolName > a.schoolName) ? -1 : 0));
			}, err => {
				this.msg.error(this.isvc.getUserErrorDefault(err));
				console.log(err);
			});
		}
	}

	setDefault(idx: number) {
		this.isvc.setDefaultApi(this.data[idx]).subscribe(() => {
			this.msg.success('Default school access changed to ' + this.data[idx].schoolName);
		},
			err => {
				console.log(err);
				this.msg.error(this.isvc.getUserErrorDefault(err));
			});
		for (var d in this.data) {
			if (this.data[d] != this.data[idx]) {
				this.data[d].isDefault = false;
			}
		}
	}

	changeUserRoles(idx: number) {
		this.isvc.setUserRoles(this.data[idx]);
		if (this.isvc.containsUserRole(this.data[idx], 'admin')) {
		}

		// trigger app component reload
		this.app.onLoadApp.emit(null);

		this.router.navigate([`idp/${this.data[idx].acctNumber}/idps/`]);
	}

}
